import { render, staticRenderFns } from "./CapacitorMaker.vue?vue&type=template&id=0bc9879b&scoped=true&"
import script from "./CapacitorMaker.vue?vue&type=script&lang=js&"
export * from "./CapacitorMaker.vue?vue&type=script&lang=js&"
import style0 from "./CapacitorMaker.vue?vue&type=style&index=0&id=0bc9879b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc9879b",
  null
  
)

export default component.exports